export const GETTER_REWARD_ACCESS_TOKEN = "GETTER_REWARD_ACCESS_TOKEN";
export const GETTER_LIST_REWARD_ACCESS_TOKEN =
  "GETTER_LIST_REWARD_ACCESS_TOKEN";
export const GETTER_LIST_REWARD_ACCESS_TOKEN_PAGINATION =
  "GETTER_LIST_REWARD_ACCESS_TOKEN_PAGINATION";

export const ACTION_SET_REWARD_ACCESS_TOKEN_STATE =
  "ACTION_SET_REWARD_ACCESS_TOKEN_STATE";
export const ACTION_ADD_REWARD_ACCESS_TOKEN = "ACTION_ADD_REWARD_ACCESS_TOKEN";
export const ACTION_EDIT_REWARD_ACCESS_TOKEN =
  "ACTION_EDIT_REWARD_ACCESS_TOKEN";
export const ACTION_DELETE_REWARD_ACCESS_TOKEN =
  "ACTION_DELETE_REWARD_ACCESS_TOKEN";
export const ACTION_GET_LIST_REWARD_ACCESS_TOKEN =
  "ACTION_GET_LIST_REWARD_ACCESS_TOKEN";
export const ACTION_GET_REWARD_ACCESS_TOKEN_DETAIL =
  "ACTION_GET_REWARD_ACCESS_TOKEN_DETAIL";

export const MUTATION_SET_REWARD_ACCESS_TOKEN =
  "MUTATION_SET_REWARD_ACCESS_TOKEN";
export const MUTATION_SET_LIST_REWARD_ACCESS_TOKEN =
  "MUTATION_SET_LIST_REWARD_ACCESS_TOKEN";



// WEBPACK FOOTER //
// ./src/store/modules/basic_rewards_access_token/constants.js